import {Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2} from '@angular/core';

@Directive({
    selector: 'iframe[appIframeTracker]',
    standalone: false
})
export class IframeTrackerDirective implements OnInit {
    @Input() debug: boolean = false;
    @Output() iframeClick: EventEmitter<ElementRef> = new EventEmitter<ElementRef>();
    private iframeMouseOver: boolean = false;

    constructor(private el: ElementRef, private renderer: Renderer2) {
    }

    ngOnInit(): void {
        this.renderer.listen(window, 'blur', (): void => this.onWindowBlur());
    }

    @HostListener('mouseover')
    onIframeMouseOver(): void {
        this.log('Iframe mouse over');
        this.iframeMouseOver = true;
        this.resetFocusOnWindow();
    }

    @HostListener('mouseout')
    onIframeMouseOut(): void {
        this.log('Iframe mouse out');
        this.iframeMouseOver = false;
        this.resetFocusOnWindow();
    }

    private onWindowBlur(): void {
        if (this.iframeMouseOver) {
            this.log('WOW! Iframe click!!!');
            this.resetFocusOnWindow();
            this.iframeClick.emit(this.el);
        }
    }

    private resetFocusOnWindow(): void {
        setTimeout((): void => {
            this.log('reset focus to window');
            window.focus();
        }, 100);
    }

    private log(message: string): void {
        if (this.debug) {
            console.log(message);
        }
    }
}
